export default "__VITE_PUBLIC_ASSET__2c65ebf3__"